import { render, staticRenderFns } from "./MemberAddForm.vue?vue&type=template&id=6617ffb9&"
import script from "./MemberAddForm.vue?vue&type=script&lang=js&"
export * from "./MemberAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports